import { createSlice } from '@reduxjs/toolkit';

export const bodyReducer = createSlice({
  name: 'upperbody',
  initialState: {
    upperBody: `<p style="text-align: center">ग्राम&nbsp;_____, ग्राम पंचायत -&nbsp;_____, प.ह.न.-&nbsp;__, रा.नि.म-&nbsp;_____&nbsp;जिला-&nbsp;___________&nbsp;(छ.ग.)</p><p style="text-align: center">जाति-&nbsp;___</p>`,
    lowerBody: `<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;प्रमाणित किया जाता है कि&nbsp;________&nbsp;पिता&nbsp;________&nbsp;जाति&nbsp;_____&nbsp;ग्राम&nbsp;______, ग्राम   पंचायत-&nbsp;_______, वि.ख.-&nbsp;_________, जिला-&nbsp;____________&nbsp;(छ.ग.) का निवास है। जिन्हें    स्थायी जाति/निवास प्रमाण-पत्र हेतु यह वंशवृक्ष प्रदान किया जाता है।</p><p>उपरोक्त वंशावली सत्य है।</p>`,
  },
  reducers: {
    editUpperBody: (state, action) => {
      state.upperBody = action.payload;
    },
    editLowerBody: (state, action) => {
      state.lowerBody = action.payload;
    },
  },
});

export default bodyReducer.reducer;
export const { editLowerBody, editUpperBody } = bodyReducer.actions;
